var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-editor"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{ref:"editor",style:(`height: ${_vm.height}px`),attrs:{"id":"editor"},domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }